import Link from 'next/link'
import React from 'react'

import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'

export const Agreement = ({ className }: { className?: string }) => {
  return (
    <div className={clsx('text-x-sm leading-x-sm', className)}>
      <FormattedMessage
        defaultMessage="Оплачивая, вы соглашаетесь с <terms>правилами</terms> и <policy>политикой</policy>"
        id="payment.block.termsAndPolicy"
        values={{
          terms: (chunks) => (
            <Link
              className="text-blue-600 transition-colors hover:text-primary-500"
              target="_blank"
              href={{
                pathname: '/docs/[name]',
                query: { name: 'terms_of_service' }
              }}
            >
              {chunks}
            </Link>
          ),
          policy: (chunks) => (
            <Link
              className="text-blue-600 transition-colors hover:text-primary-500"
              target="_blank"
              href={{
                pathname: '/docs/[name]',
                query: { name: 'privacy_policy' }
              }}
            >
              {chunks}
            </Link>
          ),
          br: <br />
        }}
      />
    </div>
  )
}
